import { Link, styled, Text, useTranslation } from '@obvio/app'
import { SvgShare } from '@obvio/svg'
import { Button, Stack } from '@obvio/ui'

import { ShareDropdown } from '../ShareDropdown'

import type { AllowNullishForOptional } from '@obvio/utils'
import type { ReactElement } from 'react'

const Record = styled.div`
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
  width: 100%;
`

const RecordCenter = styled(Record)`
  align-items: center;
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: black;
`

const FullWidthButton = styled(Button)`
  width: 100%;
`

type EventRegisterInlineProps = AllowNullishForOptional<{
  place?: string
  placeUrl?: string
  time: string
  handleRegister(): void
}>

export function EventRegisterInline({
  place,
  placeUrl,
  time,
  handleRegister,
}: EventRegisterInlineProps): ReactElement {
  const { t } = useTranslation()
  return (
    <Stack kind="vertical" fullWidth>
      <FullWidthButton onClick={handleRegister}>
        {t('event.register')}
      </FullWidthButton>
      <Record>
        <Text tag="span">{t('label.when')}</Text>
        <Text tag="span">{time}</Text>
      </Record>
      {place ? (
        <Record>
          <Text tag="span">{t('label.where')}</Text>
          <Text tag="span">
            {placeUrl ? <Link href={placeUrl}>{place}</Link> : place}
          </Text>
        </Record>
      ) : null}
      <Divider />
      <ShareDropdown>
        <RecordCenter>
          <Text tag="span">{t('label.share')}</Text>
          <Button kind="icon">
            <SvgShare />
          </Button>
        </RecordCenter>
      </ShareDropdown>
    </Stack>
  )
}
